import { GridTableVisibleColumnsContext } from 'components/GridTable/context'
import type {
  GridTableColumn,
  GridTableContentSectionItem,
  PossibleValuesRecord,
} from 'components/GridTable/types'
import { useContext, useMemo } from 'react'
import { LabelCell } from './LabelCell/LabelCell'
import { ValueCell } from './ValueCell/ValueCell'

export const ItemRow = ({
  columns,
  height,
  label,
  labelCellCSS,
  render,
  values,
  widthForLabelColumn,
  widthForValueColumns,
}: {
  columns: GridTableColumn[]
  height: number
  label: React.ReactNode
  labelCellCSS?: GridTableContentSectionItem['labelCellCSS']
  render: GridTableContentSectionItem['render']
  // TODO: use the generic to get the columns' keys
  values: Record<string, PossibleValuesRecord>
  widthForLabelColumn: number
  widthForValueColumns: number
}) => {
  const { startIndex, endIndex } = useContext(GridTableVisibleColumnsContext)

  const valueCells = useMemo(
    () =>
      columns
        .slice(startIndex, endIndex)
        .map((column) => (
          <ValueCell
            key={column.key}
            column={column}
            render={render}
            value={values[column.dataIndex]}
            values={values}
            width={widthForValueColumns}
          />
        )),
    [columns, render, values, widthForValueColumns, startIndex, endIndex],
  )

  return (
    <div
      css={{
        height,
        display: 'flex',
        transition: 'height 200ms, opacity 200ms',
      }}
    >
      <LabelCell cellCSS={labelCellCSS} height={height} width={widthForLabelColumn}>
        {label}
      </LabelCell>
      <div css={{ flexShrink: 0, width: startIndex * widthForValueColumns }} />
      {valueCells}
    </div>
  )
}
